import moment from 'moment'

export default function (d) {
  return moment(d).format('DD/MM/YYYY HH[h]mm')
}



// WEBPACK FOOTER //
// ./src/utils/fullDateFormatter.js